export interface IScheduleResponse {
  rangeFrom: number;
  rangeTo: number;
  percent: number;
}

export type IScheduleData = IScheduleResponse;

export const convertIScheduleResponseToIScheduleData = (response: IScheduleResponse): IScheduleData => ({
  ...response,
});
